// Tlačítko „načíst znovu" do headeru. Řidič si tím vynutí čerstvá data ze
// serveru (zásah dispečera, storno, přehozená zastávka) bez restartu appky.

import { useState } from "react";
import { useSyncStore } from "../store/syncStore";
import { hardRefresh } from "../lib/refresh";

export function RefreshButton() {
  const online = useSyncStore((s) => s.online);
  const [state, setState] = useState<"idle" | "busy" | "done">("idle");

  const handleClick = async () => {
    if (state === "busy") return;
    setState("busy");
    try {
      await hardRefresh();
      setState("done");
      setTimeout(() => setState("idle"), 1500);
    } finally {
      setState((s) => (s === "busy" ? "idle" : s));
    }
  };

  return (
    <button
      onClick={() => void handleClick()}
      disabled={!online}
      title={online ? "Načíst znovu ze serveru" : "Offline — není odkud načíst"}
      aria-label="Načíst znovu"
      style={{
        background: "transparent",
        border: "none",
        padding: "0 8px",
        cursor: online ? "pointer" : "default",
        opacity: online ? 1 : 0.4,
        color: "var(--soft)",
        fontSize: 17,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <span
        style={{
          display: "inline-block",
          animation: state === "busy" ? "rdr-spin 0.8s linear infinite" : "none",
        }}
      >
        {state === "done" ? "✓" : "⟳"}
      </span>
    </button>
  );
}
